import { render } from "./TheAdminResourceCategoryShow.vue?vue&type=template&id=70f0bcb2&ts=true"
import script from "./TheAdminResourceCategoryShow.vue?vue&type=script&lang=ts"
export * from "./TheAdminResourceCategoryShow.vue?vue&type=script&lang=ts"

import "./TheAdminResourceCategoryShow.vue?vue&type=style&index=0&id=70f0bcb2&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__